import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const TransfersTypes = ({ form, transfersTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Экскурсионная подготовка">
      {getFieldDecorator('transfer_preparation_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {transfersTypes &&
            transfersTypes.map(type => (
              <Option
                key={type.transferPreparationKey}
                value={type.transferPreparationKey}
                label={type.transferPreparation}
              >
                {type.transferPreparation}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(TransfersTypes, ['transfersTypes']);
